import React from "react";
import { AppName } from "../../config";
import { showModal } from "../../utils/modalUtility";
import HelpModal from "./Help";
import LicenseModal from "./License";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  function openHelpModal() {
    showModal("helpModal");
  }
  function openLicenseModal() {
    showModal("licenseModal");
  }

  return (
    <footer className="footer">
      <div className="container-fluid d-flex justify-content-between">
        <nav className="pull-left">
          <ul className="nav">
            <li className="nav-item">
              <button className="nav-link" onClick={openHelpModal}>
                Help
              </button>
            </li>
            <li className="nav-item">
              <button className="nav-link" onClick={openLicenseModal}>
                Licenses
              </button>
            </li>
          </ul>
        </nav>
        <div className="copyright">
          © Copyright {currentYear}. {AppName.appName}, LLC. All Rights Reserved
        </div>
        <div>
          Design and Developed by{" "}
          <a
            href="https://www.developersstreet.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Developers Street
          </a>
        </div>
      </div>

      <HelpModal />
      <LicenseModal />
    </footer>
  );
};

export default Footer;
